namespace SorAraBul.Administration {
    export interface UserRoleRow {
        UserRoleId?: number;
        UserId?: number;
        RoleId?: number;
        Username?: string;
        User?: string;
    }

    export namespace UserRoleRow {
        export const idProperty = 'UserRoleId';
        export const localTextPrefix = 'Administration.UserRole';
        export const lookupKey = 'Administration.UserRole';

        export function getLookup(): Q.Lookup<UserRoleRow> {
            return Q.getLookup<UserRoleRow>('Administration.UserRole');
        }
        export const deletePermission = 'Administration:CompanyAdmin';
        export const insertPermission = 'Administration:CompanyAdmin';
        export const readPermission = 'Administration:CompanyAdmin';
        export const updatePermission = 'Administration:CompanyAdmin';

        export declare const enum Fields {
            UserRoleId = "UserRoleId",
            UserId = "UserId",
            RoleId = "RoleId",
            Username = "Username",
            User = "User"
        }
    }
}
